import LazyDisp from "../class/lazydisp";

const [ w, d ] = [window, document ];

const domReady = () => false;

const jqInit = () => false;

const onLoadHtml = () => {
  // LazyDisp開始
  new LazyDisp('[data-lazydisp]');

  //ローカルナビブロック挿入
  const featuresNav = $.get('/src/html/nav-features.html');
  featuresNav.done( html => {
    $('.rwd002-detail__entry').append( html );
    //currentMenu
    $('[data-plugin=currentMenu]').currentMenu({mode:0, default:999});
  });

  //overflow-x:scroll内の画像の初期位置を中央にする
  if( d.body.classList.contains('is--article-2') ) {
    const img = d.querySelector('.capability-partner__img');
    const imgInner = d.querySelector('.capability-partner__img-inner');
    const imgWidth = parseInt(img.clientWidth);

    if( imgWidth > w.innerWidth ) imgInner.scrollLeft = parseInt((imgWidth - w.innerWidth) / 2);
  }
};

export default function FEATURES () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
  $(() => Promise.all([w.load['loadHtml']]).then( onLoadHtml ) );
}
